import LoadingButton from "@mui/lab/LoadingButton";
import IconButton from "@mui/material/IconButton";
import styled from "@mui/material/styles/styled";

import { Row } from "@rui/Stack";

export const EditMenuContainer = styled(Row)(({ theme }) => ({
  flex: 1,
  [theme.breakpoints.down("mobile")]: {
    "& .gte-mobile": {
      display: "none",
    },
  },
  "& .hidden": {
    display: "none",
  },
}));

export const EditMenuButton = styled(LoadingButton)(({ theme }) => ({
  padding: theme.spacing(1),
  minWidth: 0,
  width: "fit-content",
  minHeight: "34px",
  [theme.breakpoints.down("mobile")]: {
    "& .MuiButton-startIcon": {
      margin: 0,
    },
  },
  [theme.breakpoints.up("mobile")]: {
    padding: theme.spacing(1, 1.5),
  },
}));

export const UndoRedoButton = styled(IconButton)(({ theme }) => ({
  border: "1px solid",
  borderColor: theme.palette.shades.neutral[100],
  borderRadius: theme.corners.base,
  padding: theme.spacing(1),
  "& .MuiSvgIcon-root": {
    fontSize: "16px",
    color: theme.palette.shades.neutral[600],
  },
  "&.Mui-disabled": {
    borderColor: theme.palette.shades.neutral[50],
    backgroundColor: theme.palette.shades.neutral[50],
    "& .MuiSvgIcon-root": {
      fontSize: "16px",
      color: theme.palette.shades.neutral[400],
    },
  },
  [theme.breakpoints.up("mobile")]: {
    padding: theme.spacing(1, 1.5),
  },
}));
